export default {
  tableDataReports: state => {
    return state.reportsList
  },
  tableDataEwalletReports: state => {
    return state.eWalletReport
  },
  tableDataEwalletPopupReports: state => {
    return state.eWalletPopupReport
  },
  tableDataEwalletIndividualReport: state => {
    return state.eWalletIndividualReport
  },
  tableVisitorHistoryList: state => {
    return state.visitorHistoryList
  },
}
